import { Base } from "./components/Base";
import { Customer, CustomerInRedux, CustomerState, CustomerListModel, PartialCustomerListModel, PartialCustomerModelInRedux } from "./model";
import { customers as reducer } from "./reducer";
import { routes } from "./routes";
import { loadCustomers, loadCustomersSuccess } from "./actions";
import * as selectors from "./selectors";
import { CoreDetails } from "./components/details/CoreDetails";
import { customerApi } from "./customerApi";

export {
    Customer,
    CustomerInRedux,
    CustomerListModel,
    PartialCustomerListModel,
    PartialCustomerModelInRedux,
    reducer,
    CustomerState,
    routes,
    loadCustomers,
    loadCustomersSuccess,
    selectors,
    Base,
    CoreDetails,
    customerApi
};
